import { ElementController, selectAll } from 'js-common';
import Flickity from 'flickity';
import { CARD_SLIDER_CONTROLLER_ID } from './constants';

/**
 * Controller for news and event cards slider.
 *
 * @extends {ElementController}
 */
export default class CardSlider extends ElementController {
  static id = CARD_SLIDER_CONTROLLER_ID;

  /**
   * DOM and images loaded, instantiate slider.
   */
  load() {
    // Init slider
    this.slider = new Flickity(this.root, this.getSliderOptions());

    // Get focusable elements for each cell for toggling in checkFocusable.
    // Exclude elements that are already disabled and should stay that way.
    this.cellFocusables = this.slider.cells.map((cell) =>
      selectAll(cell.element, this.getFocusableSelector()).filter(
        (control) => control.tabIndex !== -1,
      ),
    );

    // Run initial pass on page load
    this.checkFocusable();

    // Bind events
    this.slider.on('select', this.handleCellChange);
  }

  /**
   * Get selector for focusable elements.
   */
  getFocusableSelector() {
    return 'a, button';
  }

  /**
   * Get Flickity slider options.
   */
  getSliderOptions() {
    return {
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      pageDots: false,
      freeScroll: window.innerWidth < 600,
      /* eslint-disable */
      // prettier-ignore
      arrowShape: {
          x0: 10,
          x1: 40, y1: 40,
          x2: 55, y2: 40,
          x3: 25,
        },
      /* eslint-enable */
    };
  }

  /**
   * Enable and disable tabbing on cell elements depending on aria-hidden
   * (which is handled by Flickity).
   */
  checkFocusable = () => {
    this.slider.cells.forEach((cell, i) => {
      const focusables = this.cellFocusables[i];
      const isDisabled = cell.element.getAttribute('aria-hidden') === 'true';
      focusables.forEach((el) => {
        /* eslint-disable no-param-reassign */
        el.tabIndex = isDisabled ? -1 : 0;
      });
    });
  };

  /**
   * Check focusables when the current active cell is changed.
   */
  handleCellChange = () => {
    this.checkFocusable();
  };
}
